<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

<div *ngIf="!isLoading" class="table-responsive p-l-20 p-r-20">
  <div (click)="create()" class="btn btn-primary float-end">Create</div>

  <table class="table table-borderless align-middle tableStyle webhook-list-table">
    <colgroup>
      <col class="webhook-name-col">
      <col class="webhook-type-col">
      <col class="webhook-actions-col">
    </colgroup>
    <thead>
    <tr>
      <th>Webhook</th>
      <th class="text-center">Type</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of this.filterData() ">
      <td class="webhook-name-cell">
        <span class="divLink" (click)="edit(row.Id)">
          {{row.Name}} - https://{{browserHostname}}/webhook/{{row.WebHookUniqueIdentifier}}
        </span>
      </td>
      <td class="text-center">{{ getWebhookType(row) }}</td>
      <td class="text-end">
        <i class="fas fa-cog m-r-20 divLink" (click)="edit(row.Id)"></i>
        <i class="far fa-trash-alt divLink" (click)="delete(row.Id)"></i>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<style>
  .webhook-list-table {
    table-layout: fixed;
    width: 100%;
  }

  .webhook-name-col {
    width: 45%;
  }

  .webhook-type-col {
    width: 25%;
  }

  .webhook-actions-col {
    width: 30%;
  }

  .webhook-name-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .webhook-list-table thead th,
  .webhook-list-table thead tr {
    border: none !important;
  }

  .webhook-list-table tbody tr {
    border-bottom: 1px solid #ebeff2;
  }

  #rootContainer.darkTheme .webhook-list-table tbody tr {
    border-bottom: 1px solid #1f272c;
  }
</style>
